import React, {Fragment, createContext, useEffect, useState, useContext, useReducer} from 'react';
import {NavLink, Link, Route} from "react-router-dom";
import Login, {loginLogo} from './login'
import Site from './site';
import VisitManage from "./visit";
import VisitApplication from "./visitor-application";
import System from "./system";
import Contents from "./contents";
import Staff from "./staff";
import {reducer} from "./auth";
import SiteSelect from "../../component/visit-application/site-select";
import {set} from "react-hook-form";

export const HostStateContext = createContext(null);
export const HostDispatchContext = createContext(null);

export default function AdminRouter(props) {
    const [ state, dispatch ] = useReducer(reducer, null);
    const [ lnbFlag, setLnbFlag ] = useState(false);

    useEffect(() => {
        let adminVersion = localStorage.getItem('app.admin.ver');
        if(!adminVersion) {
            localStorage.clear();
        } else {
            const hostInfoStr = localStorage.getItem('hostInfo');
            if (hostInfoStr) {
                try {
                    const hostInfo = JSON.parse(hostInfoStr);
                    dispatch({ type: 'LOGIN', hostInfo });
                } catch {}
            }
        }

        const checkSession = () => {
            const loginTimeStr = localStorage.getItem('loginTime');
            if (!loginTimeStr) return;

            const min = (Date.now() - Number(loginTimeStr)) / 60000;
            if (min >= 60) {
                localStorage.clear();
                alert('세션이 만료되었습니다. 다시 로그인 해주세요.');
                window.location.reload();
            }
        };

        checkSession();
        const id = setInterval(checkSession, 60_000);
        return () => clearInterval(id);
    }, [dispatch])

    return (
        <HostStateContext.Provider value={state}>
            <HostDispatchContext.Provider value={dispatch}>
            {
                state == null
                    ? <Login />
                    : <div className={'admin nv_wrap'}>
                        <Lnb lnbFlag={lnbFlag} setLnbFlag={setLnbFlag} />
                        <div className={'nv_container'}>
                            <Header setLnbFlag={setLnbFlag} />
                            <div className="nv_contents_wrap">
                                <div className="nv_contents">
                                    <Route exact={true} path={["/admin/", "/admin/visitor-list"]} component={VisitManage}/>
                                    <Route path={"/admin/visitor-application"} component={VisitApplication} />
                                    <Route path={"/admin/site-manage"} component={Site}/>
                                    <Route path={"/admin/contents-manage"} component={Contents}/>
                                    <Route path={"/admin/system-manage"} component={System}/>
                                    <Route path={"/admin/staff-manage"} component={Staff}/>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
            }
            </HostDispatchContext.Provider>
        </HostStateContext.Provider>
    )
}

function Header( { setLnbFlag } ) {
    const dispatch = useContext(HostDispatchContext);
    const { hostInfo } = useContext(HostStateContext);
    const logout = () => {
        dispatch({type : 'LOGOUT'});
    }

    return (
        <Fragment>
            <div className={`nv_top tpc_skip m_skip`}>
                <div className={'nv_login_info_pc'}>
                    {
                        hostInfo != undefined &&
                        <p className="nv_bold">
                            <span className="nv_blue">{hostInfo.name}</span>
                            ({hostInfo.siteInfo.parentSiteInfo.name},{hostInfo.siteInfo.name})
                            님, 반갑습니다. 좋은 하루 되세요.
                        </p>
                    }
                    <button
                        type="button"
                        className="nv_blue_button"
                        style={{lineHeight: '0px'}}
                        onClick={logout}>
                        로그아웃
                    </button>
                    <SiteSelect />
                </div>
            </div>
            <div className="nv_m_header pc_skip">
                <p className="nv_toggle" onClick={()=> setLnbFlag(true)}>
                    {
                        menu_icon()
                    }
                </p>
            </div>
        </Fragment>
    )
}

function Lnb( {lnbFlag, setLnbFlag } ) {
    const dispatch = useContext(HostDispatchContext);
    const { auth } = useContext(HostStateContext);
    const logout = () => {
        dispatch({type : 'LOGOUT'});
    }

    function goMain() {
        window.location.href = "/admin/visitor-list";
    }

    return (
        <Fragment>
            <div className={(lnbFlag ? 'nv_lnb on' : 'nv_lnb')}>
                <h1 className="nv_logo normal tpc_skip m_skip" onClick={goMain}>
                    {
                        loginLogo('90%')
                    }
                </h1>
                <div className="nv_m_profile pc_skip">
                    {
                        logo('100%')
                    }
                    <div className="name_box">
                        <p className="username"></p>
                        <p className="userid"></p>
                    </div>
                    <button type="button" className="nv_logout" onClick={() => setLnbFlag(false)}>
                        {
                            menu_close()
                        }
                    </button>
                    <button type="button" className="nv_logout" onClick={logout}>
                        {
                            logout_icon()
                        }
                    </button>
                </div>
                <nav>
                    <ul className="nv_lnv_level1">
                        {
                            auth.access.urls.map((row, index) => (
                                <li key={`admin-lnb-key-${index}`} onClick={()=> setLnbFlag(false)}>
                                    <NavLink to={row.url} activeClassName={"on"} >{row.name}</NavLink>
                                </li>
                            ))
                        }
                    </ul>
                </nav>
            </div>
        </Fragment>
    )
}

function Footer() {
    return (
        <footer className="pc_skip nv_footer">
            <address>COPYRIGHT ⓒ Neovision CO. ALL RIGHTS RESERVED.</address>
        </footer>
    )
}

function logo(width: string) {
    return (
        <svg width={width} height="50" viewBox="0 0 301 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_769_4465)">
                <path
                    d="M15.0051 14.9004C11.6637 14.9004 8.83358 15.3979 6.55199 16.6827C4.85015 17.5896 3.0548 19.4223 2.64337 21.4943C1.92024 25.0715 6.21536 27.0364 7.83616 27.3702L11.1775 28.2897C12.9729 28.7494 14.1885 29.1588 13.8518 30.601C13.6461 31.5079 12.6736 32.8304 10.7287 32.8304C9.28242 32.8304 8.39721 32.0873 8.24137 31.426C8.04812 30.7206 8.2289 29.9334 8.31617 29.5681H0.262037C-1.3837 36.2502 5.04963 36.9933 9.66268 36.9933C11.645 36.9933 20.6156 36.8674 22.2426 29.8578C22.9657 26.7593 19.5059 24.7125 17.4612 24.1709L12.5427 22.6468C11.2648 22.3193 10.4232 21.8658 10.7037 20.6692C11.003 19.3908 12.4492 18.7421 13.7646 18.7421C15.0799 18.7421 15.9028 19.3152 16.1085 19.9702C16.283 20.5874 16.096 21.3746 15.9526 21.9918H23.639C24.6239 16.2229 19.8987 14.9067 15.0176 14.9067L15.0051 14.9004Z"
                    fill="#0095D5"/>
                <path
                    d="M40.0273 15.9018C31.5306 15.9018 26.9674 20.3481 25.5648 26.4633C25.01 28.888 24.929 31.8606 26.9051 34.046C28.5695 35.9101 30.8947 36.9808 35.6325 36.9808C40.0273 36.9808 42.6518 35.7527 44.8274 34.1216C47.5204 32.0558 49.0851 29.121 49.7521 26.2177C51.3667 19.1515 46.9968 15.8955 40.0273 15.8955V15.9018ZM41.7105 26.5011C41.0746 29.2848 39.5847 32.8116 36.0751 32.8116C35.3519 32.8116 33.9182 32.736 33.3197 31.2245C32.7649 29.7571 33.0828 27.8111 33.3758 26.5011C34.0615 23.5222 35.514 20.1529 39.0611 20.1529C42.2653 20.1529 42.4959 23.0499 41.7105 26.5011Z"
                    fill="#0095D5"/>
                <path
                    d="M121.822 20.7074L121.691 16.5823H113.874L114.092 20.8271V36.5088H122.078V28.0508C122.078 25.9032 122.763 22.685 127.676 22.685C128.231 22.685 128.443 22.7291 129.384 22.8046V16.4123C127.551 16.3682 123.661 16.2548 121.822 20.7011V20.7074Z"
                    fill="#808284"/>
                <path
                    d="M152.966 23.4028C152.966 21.2615 152.455 19.3974 151.083 18.1693C148.821 16.0973 144.719 15.8643 142.792 15.8643C138.915 15.8643 135.58 16.7774 133.909 18.3645C132.288 19.9075 132.288 21.6205 132.245 22.5337H139.931C139.894 20.2665 141.303 19.5107 142.792 19.5107C145.23 19.5107 145.529 21.5009 145.492 23.6358C136.266 23.2832 130.836 25.2607 130.836 30.702C130.836 34.2352 133.142 36.8929 138.398 36.8929C142.792 36.8929 144.457 34.9909 145.448 33.6431C145.448 34.9153 145.535 35.7844 145.704 36.5024H153.39C153.01 34.5186 152.96 34.1218 152.96 32.6922V23.4028H152.966ZM144.856 30.828C144.045 32.4214 142.549 32.7363 141.702 32.7363C139.775 32.7363 138.747 31.5082 138.747 30.0345C138.747 27.1815 142.038 27.1437 145.454 27.0997C145.498 27.931 145.498 29.5621 144.856 30.828Z"
                    fill="#808284"/>
                <path d="M165.558 16.582H157.529V36.5085H165.558V16.582Z" fill="#808284"/>
                <path d="M165.646 7.91602H157.448V13.244H165.646V7.91602Z" fill="#808284"/>
                <path
                    d="M185.139 16.1348C180.7 16.1348 178.986 18.1186 178.007 19.6301L177.926 16.5756H169.891L170.103 20.8204V36.5021H178.088V25.0714C178.088 24.3598 178.088 20.8645 181.673 20.8645C184.964 20.8645 184.964 23.6859 184.964 25.0714V36.5021H192.993V24.4354C192.993 21.6958 192.993 16.1348 185.132 16.1348H185.139Z"
                    fill="#808284"/>
                <path
                    d="M67.3508 28.1265C67.0953 29.2412 66.4469 32.0941 63.0682 32.0941C59.8702 32.0941 60.4998 29.3168 60.7554 28.202L63.4173 16.5762H55.4317L52.8634 27.8053C51.9906 31.6155 51.2613 36.8553 58.6983 36.8553C60.5747 36.8553 63.3238 36.6223 66.235 33.4041L65.6989 36.5026H73.6034C73.9151 34.9534 73.9587 34.7518 74.2642 33.0514L78.0357 16.5825H70.0065L67.3571 28.1265H67.3508Z"
                    fill="#0095D5"/>
                <path
                    d="M109.236 20.2289C107.871 18.0813 105.39 16.0597 101.288 16.0597C100.521 16.0597 96.7248 16.0975 94.4931 18.6796V0.0126953L86.1709 36.5026H93.6952L93.9445 33.5678C96.6001 36.8175 99.6672 36.9371 101.082 36.9371C102.709 36.9371 105.44 36.6978 107.827 34.2731C109.629 32.4845 110.601 30.3055 110.601 26.4197C110.601 24.2721 110.389 22.093 109.236 20.2289ZM98.3082 32.453C94.4993 32.453 94.25 27.7296 94.25 26.426C94.25 24.9586 94.4993 20.3926 98.4765 20.3926C102.067 20.3926 102.323 24.3666 102.323 26.3882C102.323 27.6981 102.323 32.4593 98.3144 32.4593L98.3082 32.453Z"
                    fill="#808284"/>
                <path d="M86.1706 0L77.8359 36.5025H86.1706V0Z" fill="#0095D5"/>
                <path d="M94.4931 0H86.1709V36.5025L94.4931 0.0125957V0Z" fill="#472F92"/>
            </g>
            <path
                d="M205.641 28.667C208.778 28.667 210.737 29.7461 210.737 31.5889C210.737 33.4648 208.778 34.5439 205.641 34.5439C202.437 34.5439 200.461 33.4648 200.461 31.5889C200.461 29.7461 202.437 28.667 205.641 28.667ZM205.641 30.3105C203.648 30.3105 202.569 30.7256 202.586 31.5889C202.569 32.4521 203.648 32.9004 205.641 32.9004C207.6 32.9004 208.646 32.4521 208.646 31.5889C208.646 30.7256 207.6 30.3105 205.641 30.3105ZM210.588 19.4199V22.9229H212.63V24.6992H210.588V28.335H208.463V19.4199H210.588ZM201.158 20.3662V22.2754H204.246V20.3662H206.371V27.4717H199.05V20.3662H201.158ZM201.158 25.7949H204.246V23.9189H201.158V25.7949ZM227.106 26.8906V28.5674H221.412V31.1738H219.32V28.5674H213.277V26.8906H227.106ZM225.33 20.084V25.6455H215.004V20.084H225.33ZM217.079 21.7275V24.002H223.255V21.7275H217.079ZM225.579 32.5684V34.2617H214.904V29.8623H217.013V32.5684H225.579ZM241.085 19.4199V34.5273H239.06V19.4199H241.085ZM237.997 19.6357V33.8301H236.005V29.1484H234.229C233.664 30.6177 232.676 31.4561 231.406 31.4561C229.414 31.4561 228.119 29.3643 228.119 25.9609C228.119 22.5742 229.414 20.499 231.406 20.499C232.668 20.499 233.656 21.3208 234.229 22.7734H236.005V19.6357H237.997ZM231.406 22.4912C230.526 22.4912 230.028 23.6533 230.045 25.9609C230.028 28.2852 230.526 29.4307 231.406 29.4141C232.286 29.4307 232.817 28.2852 232.817 25.9609C232.817 23.6533 232.27 22.4912 231.406 22.4912ZM234.644 24.4668C234.71 24.9316 234.743 25.4297 234.743 25.9609C234.743 26.4839 234.71 26.9819 234.644 27.4385H236.005V24.4668H234.644ZM256.624 21.4121V23.1221H254.665V24.666H256.624V26.4258H254.665V28.335H252.54V19.4199H254.665V21.4121H256.624ZM254.665 28.9326V34.5273H252.54V30.6426H244.488V28.9326H254.665ZM246.929 20.25C249.27 20.2334 251.046 21.7939 251.046 23.9189C251.046 26.0938 249.27 27.6211 246.929 27.6211C244.571 27.6211 242.778 26.0938 242.778 23.9189C242.778 21.7939 244.571 20.2334 246.929 20.25ZM246.929 22.0596C245.733 22.0596 244.854 22.7402 244.87 23.9189C244.854 25.1309 245.733 25.8281 246.929 25.8281C248.091 25.8281 248.971 25.1309 248.987 23.9189C248.971 22.7402 248.091 22.0596 246.929 22.0596ZM263.248 22.8398C263.248 25.6123 264.51 28.4014 267.066 29.4805L265.821 31.1738C264.095 30.3936 262.899 28.8911 262.219 27.0234C261.53 29.0571 260.293 30.7007 258.45 31.5391L257.172 29.7793C259.812 28.667 261.09 25.7783 261.106 22.8398V20.582H263.248V22.8398ZM270.021 19.4199V34.5605H267.88V19.4199H270.021ZM280.016 21.4121C280.016 23.6201 281.975 25.9941 285.395 26.5752L284.465 28.335C281.833 27.812 279.875 26.3345 278.903 24.3838C277.899 26.3179 275.94 27.8037 273.325 28.335L272.412 26.5752C275.766 25.9775 277.741 23.6035 277.758 21.4121V20.3164H280.016V21.4121ZM285.893 30.9248V32.668H272.063V30.9248H285.893ZM293.114 20.3164V22.0264H289.379V23.2217H292.55V24.8486H289.379V26.1602C291.031 26.1353 292.234 26.0688 293.629 25.8447L293.845 27.4883C292.102 27.7871 290.657 27.8369 288.383 27.8369H287.354V20.3164H293.114ZM299.738 19.4199V28.4346H297.729V19.4199H299.738ZM296.733 19.6523V28.335H294.725V24.749H293.197V23.0557H294.725V19.6523H296.733ZM299.738 29.0322V34.3613H289.429V29.0322H299.738ZM291.537 30.6924V32.668H297.646V30.6924H291.537Z"
                fill="white"/>
            <defs>
                <clipPath id="clip0_769_4465">
                    <rect width="193" height="37" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    )
}

function menu_icon() {
    return (
        <svg width="100%" viewBox="-0.5 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19 3.32001H16C14.8954 3.32001 14 4.21544 14 5.32001V8.32001C14 9.42458 14.8954 10.32 16 10.32H19C20.1046 10.32 21 9.42458 21 8.32001V5.32001C21 4.21544 20.1046 3.32001 19 3.32001Z"
                stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M8 3.32001H5C3.89543 3.32001 3 4.21544 3 5.32001V8.32001C3 9.42458 3.89543 10.32 5 10.32H8C9.10457 10.32 10 9.42458 10 8.32001V5.32001C10 4.21544 9.10457 3.32001 8 3.32001Z"
                stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M19 14.32H16C14.8954 14.32 14 15.2154 14 16.32V19.32C14 20.4246 14.8954 21.32 16 21.32H19C20.1046 21.32 21 20.4246 21 19.32V16.32C21 15.2154 20.1046 14.32 19 14.32Z"
                stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M8 14.32H5C3.89543 14.32 3 15.2154 3 16.32V19.32C3 20.4246 3.89543 21.32 5 21.32H8C9.10457 21.32 10 20.4246 10 19.32V16.32C10 15.2154 9.10457 14.32 8 14.32Z"
                stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}

function logout_icon() {
    return (
        <svg width="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15 16.5V19C15 20.1046 14.1046 21 13 21H6C4.89543 21 4 20.1046 4 19V5C4 3.89543 4.89543 3 6 3H13C14.1046 3 15 3.89543 15 5V8.0625M11 12H21M21 12L18.5 9.5M21 12L18.5 14.5"
                stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}

function menu_close() {
    return (
        <svg width="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.00386 9.41816C7.61333 9.02763 7.61334 8.39447 8.00386 8.00395C8.39438 7.61342 9.02755 7.61342 9.41807 8.00395L12.0057 10.5916L14.5907 8.00657C14.9813 7.61605 15.6144 7.61605 16.0049 8.00657C16.3955 8.3971 16.3955 9.03026 16.0049 9.42079L13.4199 12.0058L16.0039 14.5897C16.3944 14.9803 16.3944 15.6134 16.0039 16.0039C15.6133 16.3945 14.9802 16.3945 14.5896 16.0039L12.0057 13.42L9.42097 16.0048C9.03045 16.3953 8.39728 16.3953 8.00676 16.0048C7.61624 15.6142 7.61624 14.9811 8.00676 14.5905L10.5915 12.0058L8.00386 9.41816Z"
                fill="#fff"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM3.00683 12C3.00683 16.9668 7.03321 20.9932 12 20.9932C16.9668 20.9932 20.9932 16.9668 20.9932 12C20.9932 7.03321 16.9668 3.00683 12 3.00683C7.03321 3.00683 3.00683 7.03321 3.00683 12Z" fill="#fff"/>
        </svg>
    )
}